import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import './Ownercard.css';

const OwnerCard = () => {
  const { listingId } = useParams();
  const navigate = useNavigate();

  const [ownerName, setOwnerName] = useState(null);
  const [whatsapp, setWhatsapp] = useState(null);
  const [pgName, setPgName] = useState(null);
  const [roomType, setRoomType] = useState(null);
  const [rent, setRent] = useState(null);
  const [contactTime, setContactTime] = useState(null);
  const [docId, setDocId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ⏱ Auto-close after 10 minutes
    const timer = setTimeout(() => {
      alert("Session expired! Going back to the previous page.");
      navigate(-1);
    }, 10 * 60 * 1000); // 10 minutes

    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    // ❌ Disable right click / screenshot hints
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener('contextmenu', disableRightClick);
    return () => document.removeEventListener('contextmenu', disableRightClick);
  }, []);

  useEffect(() => {
    const fetchListingOwner = async () => {
      if (!listingId) {
        console.error('❌ Missing listingId');
        setLoading(false);
        return;
      }

      try {
        let listingRef = doc(db, 'house-listings', listingId);
        let listingSnap = await getDoc(listingRef);

        if (!listingSnap.exists()) {
          listingRef = doc(db, 'rent-listings', listingId);
          listingSnap = await getDoc(listingRef);
        }

        if (listingSnap.exists()) {
          const data = listingSnap.data();
          setOwnerName(data.name || 'N/A');
          setWhatsapp(data.whatsapp || null);
          setPgName(data.pgName || data.title || 'N/A');
          setRoomType(data.roomType || 'N/A');
          setRent(data.rent || data.price || 'N/A');
          setContactTime(data.contactTime || 'Anytime');
          setDocId(listingSnap.id);
        } else {
          console.warn('⚠️ Listing not found');
        }

      } catch (err) {
        console.error('🔥 Error fetching listing:', err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchListingOwner();
  }, [listingId]);

  if (loading) return <p className="loading-text">Loading owner info...</p>;

  return (
    <div className="owner-wrapper">
  <div className="owner-header">
  <h1>Owner & Listing Details</h1>
  <p className="communication-rules">
    ⚠️ Please maintain professional communication. Using slang, abusive language, or negotiating discounts is prohibited. Misuse may lead to termination from the platform.
  </p>
</div>

      <div className="owner-card">
        <div className="owner-info">
          <p><i className="fas fa-user"></i> <strong>Name:</strong> {ownerName}</p>
          <p><i className="fab fa-whatsapp"></i> <strong>WhatsApp:</strong> {whatsapp?.trim() ? whatsapp : 'Not Provided'}</p>
          <hr />
          <p><strong>PG Name:</strong> {pgName}</p>
          <p><strong>Room Type:</strong> {roomType}</p>
          <p><strong>Rent:</strong> ₹ {rent}</p>
          <p><strong>Preferred Contact Time:</strong> {contactTime}</p>
          <p><strong>Listing Id:</strong> {docId}</p>
        </div>
      </div>

      <div className="back-container">
        <button onClick={() => navigate(-1)} className="back-button">← Back</button>
      </div>
    </div>
  );
};

export default OwnerCard;
